import { render } from "./login.vue?vue&type=template&id=33ac0a22"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=33ac0a22&lang=css"

import exportComponent from "E:\\桌面\\微播app官网\\wan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__